export default __webpack_public_path__ + "static/media/bike.05931abd.jpeg";